import { Component } from '@angular/core';
import { RidGame } from '../../leerplus/rid-game';
import { STUDIO_API_DATA_PACKAGE_PROVIDER } from '../../leerplus/rid-game.provider';

@Component({
  selector: 'app-leercabine-page',
  imports: [RidGame],
  templateUrl: './leercabine-page.html',
})
export class LeercabinePage {
  dataPackageProvider = STUDIO_API_DATA_PACKAGE_PROVIDER;
}
